(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["egift-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.egift-hero').forEach(function(hero){
  var idInput = hero.querySelector('[data-egift-id]');
  var buttons = hero.querySelectorAll('[data-egift-amount]');
  var selVal  = hero.querySelector('[data-egift-selval]');
  var ctaAmt  = hero.querySelector('[data-egift-cta-amount]');
  function pick(btn){
    buttons.forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    if (idInput) idInput.value = btn.getAttribute('data-variant');
    var label = btn.getAttribute('data-label') || '';
    if (selVal) selVal.textContent = label;
    if (ctaAmt) ctaAmt.textContent = label ? ' · ' + label : '';
  }
  buttons.forEach(function(b){ b.addEventListener('click', function(){ pick(b); }); });
  var init = hero.querySelector('[data-egift-amount][aria-pressed="true"]') || buttons[0];
  if (init) pick(init);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["egift-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.egift-rev').forEach(function(rev){
  var track = rev.querySelector('[data-egift-rev-track]');
  if(!track) return;
  function scrollBy(dir){ var card = track.querySelector('.egift-rev__card'); var w = card ? card.offsetWidth + 24 : 360; track.scrollBy({ left: dir * w, behavior:'smooth' }); }
  var p = rev.querySelector('[data-egift-rev-prev]');
  var n = rev.querySelector('[data-egift-rev-next]');
  if(p) p.addEventListener('click', function(){ scrollBy(-1); });
  if(n) n.addEventListener('click', function(){ scrollBy(1); });
});

  } catch(e) { console.error(e); }
})();
})();
